// import { t } from "_element-plus@1.0.2-beta.71@element-plus/lib/locale";
import bankapis  from "../../api/bank";

export default {
    name: "BankDirector",
    data() {
        return {
            detailVisible:false,
            userVisible:false,
            dataDetail:{},
            bankList:[],
            areaList:[],
            siteList:[],
            type:"add",
            query: {
                keyword: "",
                pageIndex: 1,
                pageSize: 10,
                BankID:"",
                AreaCode:""
            },
            tableCols:[
                {
                    "prop": "DirectorID",
                    "label": "经理编号",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "BankSiteName",
                    "label": "网点名称",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "UserName",
                    "label": "银行经理",
                    "width": "100",
                    "align": "center"
                },
                {
                  "prop": "Tel",
                  "label": "联系电话",
                  "width": "140",
                  "align": "center"
                },
                {
                  "prop": "Type",
                  "label": "网点负责人",
                  "width": "100",
                  "align": "center"
                },
                {
                    "prop": "CreateTime",
                    "label": "创建时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "300",
                    "align": "center"
                }
            ],
            tableData:[],
            pageTotal: 0,
            scrollHeight:400,
            user:{},
            userKey:"",
            userList:[],
            userCols:[
              {
                "prop": "WxNickName",
                "label": "微信名",
                "width": "",
                "align": "center"
            },
              {
                  "prop": "UserName",
                  "label": "用户名",
                  "width": "100",
                  "align": "center"
              },
              {
                "prop": "Tel",
                "label": "联系电话",
                "width": "140",
                "align": "center"
              },
              {
                  "prop": "Operation",
                  "label": "操作",
                  "width": "300",
                  "align": "center"
              }
          ],
        };
    },
    beforeCreate: function () {
      let meta = this.$route.meta
      if(meta&&meta.permBtns.length>0){
        this.permBtns = meta.permBtns
      }
  },
    created() {
      this.getData();
      this.getBankList();
      this.getAreaList();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    // watch: {
    //   dataDetail: {
    //     handler(newVal) {
    //       this.tel=newVal.UserID
    //       var userList=this.userList;
    //       for(var i=0;i<userList.length;i++)
    //       if(userList[i].UserID==newVal.UserID){
    //         var tel=userList[i].Tel;
    //         this.tel=tel;
    //       }
    //      },
    //      deep: true,
    //   }
    // },
    methods: {
        getData(){
          let param=this.query;
          bankapis.getDirectorList(param).then(res => {
                            this.$data.tableData=res.list;
                            this.$data.pageTotal=res.count
                    });
    
      },
      getBankList(){
        let param= {
          keyword: "",
          pageIndex: 0,
          pageSize: 0
         };
        bankapis.getBankList(param).then(res => {
         this.bankList=res.list
         })
      },
      getAreaList(){
        let param= {};
        bankapis.getAreaList(param).then(res => {
         this.areaList=res
         })
      },
      getSiteList(){
        this.dataDetail.BankSiteID="";
        var AreaCode=this.dataDetail.AreaCode;
        var BankID=this.dataDetail.BankID;
        if(AreaCode==""||BankID==""){
          this.siteList=[];
          return;
        }
        let param= {
          keyword: "",
          AreaCode:AreaCode,
          BankID:BankID,
          pageIndex: 0,
          pageSize: 0
         };
         var that=this;
        bankapis.getBankSiteList(param).then(res => {
                        that.siteList=res.list;
                  });
      },
      selectUser(){
        this.userVisible=true;
        this.getUserList();
      },
      getUserList(){
        let param={
          type:"1",
          keyword:this.userKey
        }
        bankapis.getUserListByMenuId(param).then(res => {
          if(this.user)res.push(this.user)
          this.userList=res;
      });
      },
      chooseUser(user){
       this.userVisible=false;
       this.user=user;

      },
      getUserState(row){
        if(this.user!=''&&this.user.UserID==row.UserID)return true;
        else return false;
      },
      getBankById(){
          let param={
            bankId: "1"
          };
         bankapis.getDirectorById(param).then(res => {
                            this.$data.form=res;
                    });
      },
      addOrUpdateBank(){
        if(this.dataDetail.BankSiteID==""){
          this.$message.error("请选择网点");
          return;
        }
        if(this.user==""){
          this.$message.error("请选择用户");
          return;
        }
          let param={
            Type:this.dataDetail.type,
            BankSiteID:this.dataDetail.BankSiteID,
            UserID:this.user.UserID
          }
          if(this.type=="add")this.addDirector(param);
          else {
            param.Id=this.dataDetail.Id;
            this.updateDirector(param);
          }
      
      },
      addDirector(param){
        bankapis.addDirector(param).then(res => {
          if(res){
           this.$message.success("新增成功");
             this.getData();
             this.$data.detailVisible=false;
          }else{
            this.$message.error("新增失败");
          }
      });
      },
       updateDirector(param){
         bankapis.updateDirector(param).then(res => {
                        if(res){
                         this.$message.success("修改成功");
                           this.getData();
                           this.$data.detailVisible=false;
                        }else{
                          this.$message.error("修改失败");
                        }
                    });
      },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        handleEmpty(){
           this.$data.query={
            keyword: "",
            pageIndex: 1,
            pageSize: 10}
        },
        handleAdd(){
          this.type="add";
          this.$data.detailVisible=true;
          this.dataDetail={
            BankID:"",
            AreaCode:"",
            type:"1",
            BankSiteID:""
          }
          this.user="";
        },
        handleUpdate(index, row){
          this.type="update";
          this.detailVisible=true;
          this.user={
            Tel:row.Tel,
            UserName:row.UserName,
            UserID:row.UserID,
            WxNickName:row.WxNickName
          };
          this.dataDetail={
            BankID:row.BankID,
            AreaCode:row.AreaCode,
            type:row.Type+"",
            Id:row.DirectorID
          }
          this.getSiteList();
          this.dataDetail.BankSiteID=row.BankSiteID;
        },
        // 删除操作
        handleDelete(index, row) {
            let that = this;
            if(row){
                that.$confirm('确定删除吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let param={
                    Id:row.DirectorID
                  };
                 bankapis.deleteDirector(param).then(res => {
                                if(res){
                                  that.$message.success("删除成功");
                                  that.getData();
                                }else{
                                  that.$message.error("删除失败");
                                }
                            });
                }).catch(() => {
                  that.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height2=$(".content-box .content .seach-container").height();
            var height=height1-height2-112-40;
            this.scrollHeight = height;
          });
        }
    },
  
  };
